module.exports = __webpack_public_path__ + "img/yellow-circle-table-10.b11c72be.png";